import { call, put, takeEvery, getContext } from "redux-saga/effects";

import { resendVerificationLinkActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";
import {
  resendVerificationLinkFailure,
  resendVerificationLinkSuccess,
  verification,
  verificationFailure,
  verificationSuccess,
  verificationPasswordCode,
  verificationPasswordCodeSuccess,
  verificationPasswordCodeFailure,
  confirmEmailChangeSuccess,
  confirmEmailChangeFailure,
  confirmEmailChange,
} from "./actions";

const resendVerificationLinkAsync = ({ VerificationsService, email }) => {
  if (!VerificationsService) {
    console.log("Required services does not exist");

    return null;
  }

  return VerificationsService.resendVerificationLink({
    email,
  });
};

function* resendVerificationLink({ payload: { email } }) {
  try {
    const { VerificationsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(resendVerificationLinkAsync, {
      VerificationsService,
      email,
    });

    yield put(resendVerificationLinkSuccess(data));
  } catch ({ error }) {
    yield put(resendVerificationLinkFailure(error));
  }
}

const verifyEmailAsync = ({ VerificationsService, email, code }) => {
  if (!VerificationsService) {
    console.log("Required services does not exist");

    return null;
  }

  return VerificationsService.verifyEmail({
    email,
    code,
  });
};

function* verifyEmail({ payload: { email, code } }) {
  try {
    const { VerificationsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(verifyEmailAsync, {
      VerificationsService,
      email,
      code,
    });

    yield put(verificationSuccess(data));
  } catch ({ error }) {
    yield put(verificationFailure(error));
  }
}

const verifyPasswordCodeAsync = ({ VerificationsService, email, code }) => {
  if (!VerificationsService) {
    console.log("Required services does not exist");
    return null;
  }

  return VerificationsService.restorePasswordCode({
    email,
    code,
  });
};

function* verifyPasswordCode({ payload: { email, code } }) {
  try {
    const { VerificationsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(verifyPasswordCodeAsync, {
      VerificationsService,
      email,
      code,
    });

    yield put(verificationPasswordCodeSuccess(data));
  } catch ({ error }) {
    yield put(verificationPasswordCodeFailure(error));
  }
}

export function* watchResendVerificationLink() {
  yield takeEvery(
    resendVerificationLinkActionTypes.request,
    resendVerificationLink,
  );
}

const confirmEmailChangeAsync = ({
  VerificationsService,
  currentEmail,
  newEmail,
  code,
}) => {
  if (!VerificationsService) {
    console.log("Required services does not exist");
    return null;
  }

  return VerificationsService.confirmEmailChange({
    currentEmail,
    newEmail,
    code,
  });
};

function* handleConfirmEmailChange({
  payload: { currentEmail, newEmail, code },
}) {
  try {
    const { VerificationsService } = yield getContext(CONTEXT.SERVICES);
    const { data } = yield call(confirmEmailChangeAsync, {
      VerificationsService,
      currentEmail,
      newEmail,
      code,
    });

    yield put(confirmEmailChangeSuccess(data));
  } catch ({ error }) {
    yield put(confirmEmailChangeFailure(error));
  }
}

export function* watchVerifyEmail() {
  yield takeEvery(verification, verifyEmail);
}

export function* watchVerifyPasswordCode() {
  yield takeEvery(verificationPasswordCode, verifyPasswordCode);
}

export function* watchConfirmEmailChange() {
  yield takeEvery(confirmEmailChange, handleConfirmEmailChange);
}
